import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CustomerServiceNoteService } from '@uzurv/clara';
import { UzurvDirectivesModule } from '@uzurv/core';
import { RequiresPermissionsModule } from '../../components/directives';
import { TripNotesDetailComponent } from './trip-notes-detail.component';

@NgModule({
  declarations: [TripNotesDetailComponent],
  imports: [
    CommonModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    UzurvDirectivesModule,
    RequiresPermissionsModule
  ],
  exports: [TripNotesDetailComponent],
  providers: [CustomerServiceNoteService]
})
export class TripNotesDetailModule {}
